define('view/disclosure/disclosure.auto.approval.view',['require','exports','module','uikit/uikit','blockit','templates','backbone.radio','fukit'],function(require, exports, module) {
  //prettier-ignore
  var   UIKit                                         = require('uikit/uikit'),
        BlocKit                                       = require('blockit'),
        Templates                                     = require('templates'),
        Radio                                         = require('backbone.radio'),
        ShowModalOnNavigateWithUnsavedChangesBehavior = require('fukit').ShowModalOnNavigateWithUnsavedChangesBehavior;



  var EmulateCheckBoxGroupBehavior = Mn.Behavior.extend({
    onFirstBeforeRender: function() {
      this.listenTo(this.view, 'change:value', function(view, currentValue) {
        if (currentValue) {
          var changedField = this.getOption('radioModel').changed;

          // This logic implements behaviors of 2 checkbox groups (1-2 and 3-4)
          if (changedField.selected_1) {
            this.getOption('radioModel').set({ selected_2: false });
            this.getOption('settingsModel').set({ annualAutoApprove: false });
          } else if (changedField.selected_2) {
            this.getOption('radioModel').set({ selected_1: false });
            this.getOption('settingsModel').set({ annualAutoApprove: true });
          } else if (changedField.selected_3) {
            this.getOption('radioModel').set({ selected_4: false });
            this.getOption('settingsModel').set({ researchAutoApprove: false });
          } else if (changedField.selected_4) {
            this.getOption('radioModel').set({ selected_3: false });
            this.getOption('settingsModel').set({ researchAutoApprove: true });
          }
        }
      });
    },
  });

  var EmulateToggleBoxWith2ModelsBehavior = Mn.Behavior.extend({
    onFirstBeforeRender: function() {
      this.listenTo(this.view, 'change:value', function() {
        var changedField = this.getOption('radioModel').changed;
        // ignore 'undefined'
        if (changedField.selected_5 === true) {
          this.getOption('settingsModel').set({ annualAutoAssign: true });
        } else if (changedField.selected_5 === false) {
          this.getOption('settingsModel').set({ annualAutoAssign: false });
        }
        if (changedField.selected_6 === true) {
          this.getOption('settingsModel').set({ researchAutoAssign: true });
        } else if (changedField.selected_6 === false) {
          this.getOption('settingsModel').set({ researchAutoAssign: false });
        }
      });
    },
  });

  var InitializeCheckBoxGroupBehavior = Mn.Behavior.extend({
    onFirstBeforeRender: function() {
      // setting values for the first checkbox group from DB values
      if (this.getOption('settingsModel').get('annualAutoApprove')) {
        this.getOption('radioModel').set({ selected_2: true });
      } else {
        this.getOption('radioModel').set({ selected_1: true });
      }
      // setting values for the second checkbox group from DB values
      if (this.getOption('settingsModel').get('researchAutoApprove')) {
        this.getOption('radioModel').set({ selected_4: true });
      } else {
        this.getOption('radioModel').set({ selected_3: true });
      }

      if (this.getOption('settingsModel').get('annualAutoAssign')) {
        this.getOption('radioModel').set({ selected_5: true });
      }

      if (this.getOption('settingsModel').get('researchAutoAssign')) {
        this.getOption('radioModel').set({ selected_6: true });
      }
    },
  });

  var DisclosureAutoApprovalPageView = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      modals: {},

      root: {
        type: BlocKit.FullWidthLayoutView,

        pageHeader: {
          headerText: 'Automate Approvals & Assignments',
          actions: [],
        },
        contentColumn: {
          components: [
            {
              type: BlocKit.FormContainerView,
              behaviors: {
                initializeCheckBoxGroupBehavior: {
                  radioModel: '@resources.checkBoxGroupModel',
                  settingsModel: '@resources.campaignManagerModel',
                  behaviorClass: InitializeCheckBoxGroupBehavior,
                },
              },

              components: [
                {
                  type: UIKit.Header,
                  text: 'Approvals',
                  tagName: 'h3',
                },

                {
                  type: UIKit.Header,
                  text: 'Annual Disclosures',
                  tagName: 'h5',
                },
                {
                  type: UIKit.Checkbox,
                  template: Templates.App['local.checkbox'],
                  radio: true,
                  useLabel: true,
                  className: 'ui checkbox radio checkbox-group-item',
                  checkboxId: 'annualManuallyOption',
                  model: '@resources.checkBoxGroupModel',
                  bindings: {
                    text: 'label_1',
                    value: 'selected_1',
                  },
                  behaviors: {
                    emulateCheckBoxGroupBehavior: {
                      radioModel: '@resources.checkBoxGroupModel',
                      settingsModel: '@resources.campaignManagerModel',
                      behaviorClass: EmulateCheckBoxGroupBehavior,
                    },
                  },
                },

                {
                  type: UIKit.Checkbox,
                  template: Templates.App['local.checkbox'],
                  radio: true,
                  useLabel: true,
                  className: 'ui checkbox radio checkbox-group-item',
                  checkboxId: 'annualAutoOption',
                  model: '@resources.checkBoxGroupModel',
                  bindings: {
                    text: 'label_2',
                    value: 'selected_2',
                  },
                  behaviors: {
                    emulateCheckBoxGroupBehavior: {
                      radioModel: '@resources.checkBoxGroupModel',
                      settingsModel: '@resources.campaignManagerModel',
                      behaviorClass: EmulateCheckBoxGroupBehavior,
                    },
                  },
                },

                {
                  type: UIKit.Header,
                  text: 'Research-Based Disclosures',
                  tagName: 'h5',
                },
                {
                  type: UIKit.Checkbox,
                  template: Templates.App['local.checkbox'],
                  radio: true,
                  useLabel: true,
                  className: 'ui checkbox radio checkbox-group-item',
                  checkboxId: 'rsManuallyOption',
                  model: '@resources.checkBoxGroupModel',
                  bindings: {
                    text: 'label_3',
                    value: 'selected_3',
                  },
                  behaviors: {
                    emulateCheckBoxGroupBehavior: {
                      radioModel: '@resources.checkBoxGroupModel',
                      settingsModel: '@resources.campaignManagerModel',
                      behaviorClass: EmulateCheckBoxGroupBehavior,
                    },
                  },
                },

                {
                  type: UIKit.Checkbox,
                  template: Templates.App['local.checkbox'],
                  radio: true,
                  useLabel: true,
                  className: 'ui checkbox radio checkbox-group-item',
                  checkboxId: 'rsAutoOption',
                  model: '@resources.checkBoxGroupModel',
                  bindings: {
                    text: 'label_4',
                    value: 'selected_4',
                  },
                  behaviors: {
                    emulateCheckBoxGroupBehavior: {
                      radioModel: '@resources.checkBoxGroupModel',
                      settingsModel: '@resources.campaignManagerModel',
                      behaviorClass: EmulateCheckBoxGroupBehavior,
                    },
                  },
                },
              ], // components 2
            },
            {
              type: BlocKit.FormContainerView,
              behaviors: {
                initializeCheckBoxGroupBehavior: {
                  radioModel: '@resources.checkBoxGroupModel',
                  settingsModel: '@resources.campaignManagerModel',
                  behaviorClass: InitializeCheckBoxGroupBehavior,
                },
              },

              components: [
                {
                  type: UIKit.Header,
                  text: 'Assignments',
                  tagName: 'h3',
                },
                {
                  type: UIKit.Text,
                  renderAsHtml: true,
                  text:
                    'COI disclosures will be automatically assigned to a reviewer within the department of the disclosee.',
                },
////////////////////////////////
                {
                  type: UIKit.ComponentsContainerView,
                  className: 'actions',
                  id: 'actions',

                  components: [

                    // Message START
                    {
                      type: UIKit.Message,
                      id: 'toast',
                      text: '',
                      format: '',
                      dismissable: true,
                      behaviors: {
                        setMessageState: {
                          model: '@resources.uiState',
                          optionValues: {
                            format: {
                              formatter: function(model) {
                                return model.get('fileActionSuccess') ? 'positive' : 'negative';
                              },
                            },
                            text: {
                              formatter: function(model) {
                                var successMessage = 'File successfully downloaded!';
                                var failureMessage =
                                    'Download Failed. Please try again';

                                return model.get('fileActionSuccess') ? successMessage : failureMessage;
                              },
                            },
                          },
                          behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                        },

                        whatsThatEvent: {
                          behaviorClass: Mn.Behavior.extend({
                            onFirstBeforeRender: function() {
                              this.listenTo(this.view, 'change:visible', function() {
                                if (arguments[1] === false) {
                                  // TODO: refactor later
                                  var uiStateResource = Radio.channel('AppKit.resourceService').request(
                                      'resource',
                                      'uiState'
                                  );

                                  uiStateResource.set({
                                    fileActionSuccess: false,
                                    fileActionNotify: false,
                                  });
                                }
                              });
                            },
                          }),
                        },

                        BindAndFormatOptionValuesBehavior: {
                          optionValues: {
                            visible: {
                              model: '@resources.uiState',
                              attribute: 'fileActionNotify',
                              eventName: 'change',
                              formatter: function(attribute) {
                                return attribute;
                              },
                            },
                          },
                          behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                        },
                      },
                    },
                    // Message END

                    // COI-1588 reviewer unit  report button
                    {
                      type: UIKit.Button.extend({
                        className: UIKit.Button.prototype.className + ' coi-button-unit-report',
                      }),
                      id: 'reviewerUnitButton',
                      text: 'Download Reviewer Units',
                      model: '@resources.reviewerUnitAssignmentModel',
                      floated: true,
                      size: 'tiny',

                      onPress: function () {
                        //contentView.clearErrors();

                          var uiStateResource = Radio.channel('AppKit.resourceService').request(
                              'resource',
                              'uiState'
                          );

                        this.loading = true;

                        // call to coi-service-v2 to generate report
                        this.model
                              .fetch()
                              .promise()
                              //.delay(60000) // 1 minute
                              .bind(this)
                              .then(function (resp) {
                                return window.open(resp.url, 'unitReport');
                              })
                              .done(function () {
                                  this.loading = false;

                                  uiStateResource.set({
                                      fileActionSuccess: true,
                                      fileActionNotify: true,
                                  });

                              })
                              .catch(function(error) {
                                console.error('An error occurred while fetching the model:', error);
                              });



                      },

                    },

                    // COI-1713 Primary Reviewer unit report button
                    {
                      type: UIKit.Button.extend({
                        className: UIKit.Button.prototype.className + ' coi-button-unit-report',
                      }),
                      id: 'primaryReviewerUnitButton',
                      text: 'Download Primary Reviewer Units',
                      model: '@resources.primaryReviewerUnitAssignmentModel',
                      floated: true,
                      size: 'tiny',

                      onPress: function () {


                         var uiStateResource = Radio.channel('AppKit.resourceService').request(
                              'resource',
                              'uiState'
                          );

                        this.loading = true;

                        // call to coi-service-v2 to generate report
                        this.model
                              .fetch()
                              .promise()
                              .bind(this)
                              .then(function (resp) {
                                return window.open(resp.url, 'unitReport');
                              })
                              .done(function () {
                                  this.loading = false;

                                  uiStateResource.set({
                                      fileActionSuccess: true,
                                      fileActionNotify: true,
                                  });

                              })
                              .catch(function(error) {
                                console.error('An error occurred while fetching the model:', error);
                              })

                      },

                    },
                 ],
                },
                ///////////////////////////////////////



                {
                  type: UIKit.Header,
                  text: 'Automatically assign Annual disclosures for review',
                  tagName: 'h5',
                },
                {
                  type: UIKit.Checkbox,
                  template: Templates.App['local.checkbox'],
                  toggle: true,
                  polar: true,
                  checkboxId: 'annualAutoAssignOption',
                  model: '@resources.checkBoxGroupModel',
                  bindings: {
                    value: 'selected_5',
                  },
                  behaviors: {
                    emulateCheckBoxGroupBehavior: {
                      radioModel: '@resources.checkBoxGroupModel',
                      settingsModel: '@resources.campaignManagerModel',
                      behaviorClass: EmulateToggleBoxWith2ModelsBehavior,
                    },
                  },
                },

                {
                  type: UIKit.Header,
                  text: 'Automatically assign Research-Based disclosures for review',
                  tagName: 'h5',
                },
                {
                  type: UIKit.Checkbox,
                  template: Templates.App['local.checkbox'],
                  toggle: true,
                  polar: true,
                  checkboxId: 'rsAutoAssignOption',
                  model: '@resources.checkBoxGroupModel',
                  bindings: {
                    value: 'selected_6',
                  },
                  behaviors: {
                    emulateCheckBoxGroupBehavior: {
                      radioModel: '@resources.checkBoxGroupModel',
                      settingsModel: '@resources.campaignManagerModel',
                      behaviorClass: EmulateToggleBoxWith2ModelsBehavior,
                    },
                  },
                },
              ],
            }, // components 2

            {
              type: BlocKit.FormContainerView.RowView,
              components: [
                {
                  name: 'saveButton',
                  content: {
                    type: UIKit.Button,
                    model: '@resources.campaignManagerModel',
                    text: 'Save',
                    icon: 'save',
                    color: 'primary',
                    behaviors: {
                      InvokeModelMethodOnEventBehavior: {
                        method: 'save',
                        showLoading: true,
                        onMethodSuccessEvent: 'saved:campaignManagerModel',
                        behaviorClass: BlocKit.InvokeModelMethodOnEventBehavior,
                      },
                      EnableOnlyOnUnsavedChangesBehavior: {
                        model: '@resources.campaignManagerModel',
                        behaviorClass: BlocKit.EnableOnlyOnUnsavedChangesBehavior,
                      },
                      ShowModalOnNavigateWithUnsavedChangesBehavior: {
                        behaviorClass: ShowModalOnNavigateWithUnsavedChangesBehavior,
                      },
                    },
                  },
                },
              ],
            },
          ], // components 1
        }, //contentColumn
      }, // root
    }, // resolveOptions
  });

  module.exports = DisclosureAutoApprovalPageView;
});

